import { fetchDeptUserList, fetchUserInfo, getBmxms, getDict, login } from "@/api/common";
const state = {
  deptUser: [],
  user: {

  },
  token: "",
  bmxmList: [], //部门项目
  dictList: [],
};
const mutations = {
  fetchUserInfo(state, res) {
    if (res.code == 0) {
      state.user = res.data;
    }
  },
  fetchLoginData(state, res) {
    if (res.code == 0) {
      localStorage.setItem("token", res.token);
      state.token = res.token;
    }
  },
  fetchBmxms(state, res) {
    if (res.code == 0) {
      state.bmxmList = res.data;
    }
  },

  fetchDicts(state, res) {
    if (res.code == 0) {
      state.dictList = res.data;
    }
  },

  // fetchModules(state, res) {
  //   if (res.code == 0) {
  //     state.gsyyModules = res.data;
  //   }
  // },
  fetchDeptUser(state) {
    fetchDeptUserList().then(res => {
      if (res.code === 0) {
        const bmYgRows = res.data;
        const bmArray = [];
        for (const i in bmYgRows) {
          const row = bmYgRows[i];
          row.id = row.bmbh;
          row.label = row.bmmc;
          const ygs = row.users;
          for (const j in ygs) {
            const yg = ygs[j];
            yg.id = yg.ygbh;
            yg.label = yg.ygbh + ' - ' + yg.xm;
          }
          if (ygs.length > 0) {
            bmArray.push(row)
          }
        }
        state.deptUser = bmArray;
      }
    })
  },
};
const actions = {
  fetchUserInfoAction(context, payload) {
    return new Promise((resolve, reject) => {
      fetchUserInfo()
        .then((res) => {
          context.commit("fetchUserInfo", res);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  loginAction(context, payload) {
    return new Promise((resolve, reject) => {
      login(payload)
        .then((res) => {
          context.commit("fetchLoginData", res);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchBmxmsAction(context, payload) {
    return new Promise((resolve, reject) => {
      getBmxms(payload)
        .then((res) => {
          context.commit("fetchBmxms", res);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getDeptUser(context) {
    context.commit('fetchDeptUser');
  },
  fetchDictAction(context, { dictType, type }) {
    return new Promise((resolve, reject) => {
      getDict(dictType, type)
        .then((res) => {
          context.commit("fetchDicts", res);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
